module.exports = __webpack_public_path__ + "static/media/CTLI_14-147w.ea552066.png";